import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Form, Select, Button, Input, Tooltip } from 'antd';
import { Spinner } from 'reactstrap';
import axios from '../../utils/request';
import { QuestionCircleOutlined } from '@ant-design/icons';

const { Option } = Select;
let tenantId = "";
let errorMessage = "";
let commonParamater = "";
let formRef;
let stfName = "";
let stfCode = "";

const formLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};

export class DrientalYuhong extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            reqNos: [],
            personIds: "",
            tenantId: "",
            userId: "",
            reqNo: "",
            staffName: "",
            staffNo: "",
            stfName: "",
            stfCode: "",
            commonParamater: ""
        }
    };

    formRef = React.createRef();

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        tenantId = urlParams.get("tenantId");
        let messageCode = urlParams.get("messageCode");
        if (!commonParamater) {
            this.setState({ errorMessage: "commonParamater不存在！", isLoading: false, isReady: true });
            return;
        }
        //console.log("标准系统参数", commonParamater, tenantId);

        this.state.commonParamater = commonParamater;
        this.state.tenantId = tenantId;
        this.loadPage(tenantId, commonParamater);
        //this.loadPage(430585, "1246375d-34e8-4a0d-897d-613010ccf01d");
        //this.setState({ isLoading: false, isReady: true, errorMessage: "" });
    };

    loadPage = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }

        //雨虹需求 https://service-bridge.recruit.italent.cn
        axios
            .get("/api/DrientalYuhong/GetRequirements", { params: params })
            .then(res => {
                //console.log("雨虹需求", res);
                let errorMessage = "";

                if (res.status == 200 && res.data.code == "200") {
                    this.setState({
                        reqNos: res.data.data
                    });
                }
                else {
                    errorMessage = "获取雨虹需求ID失败";
                    this.setState({ isLoading: false, isReady: true, errorMessage });
                }

                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                //console.log(reason);
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );

        //当前操作人 https://service-bridge.recruit.italent.cn
        axios
            .get("/api/DrientalYuhong/GetStaffInfo", { params: params })
            .then(res => {
                //console.log("当前操作人", res);
                let errorMessage = "";
                if (res.status == 200 && res.data.code == "200") {
                    this.state.stfName = res.data.data.name;
                    this.state.stfCode = res.data.data.code;

                    //this.formRef.current && this.formRef.current.setFieldsValue({ staffName: res.data.data.name });
                    //this.formRef.current && this.formRef.current.setFieldsValue({ staffNo: res.data.data.code });
                }
                else {
                    errorMessage = "获取Offer所有者失败";
                    this.setState({ isLoading: false, isReady: true, errorMessage });
                }

                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                //console.log(reason);
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    onFinish = async (values) => {
        //console.log("用户输入", values);
        const fieldsValue = await this.formRef.current.validateFields();
        //console.log(fieldsValue);
        const params = {
            tenantId: this.state.tenantId,
            commonParamater: this.state.commonParamater,
            reqNo: fieldsValue.reqNo,
            staffName: this.state.stfName,//fieldsValue.staffName,
            staffNo: this.state.stfCode,//fieldsValue.staffNo
        };

        const bodyString = JSON.stringify(params);
        axios
            .post("/api/DrientalYuhong/AddReqNoToApplicant", bodyString,
                {
                    headers: { "Content-Type": "application/json" }
                })
            .then(res => {
                //console.log("保存雨虹需求ID", res);
                let errorMessage = "";
                if (res.status == 200 && res.data.code == "200") {
                    errorMessage = "保存雨虹需求ID成功";
                    this.setState({ isLoading: false, isReady: true, errorMessage });
                }
                else {
                    errorMessage = "保存雨虹需求ID失败";
                    this.setState({ isLoading: false, isReady: true, errorMessage });
                }
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
            else {
                return (
                    <>
                        <div style={{ paddingTop: '18px', paddingBottom: '14px' }}>
                            <p style={{ margin: 'auto', width: '170px', fontSize:'20px' }}>共享平台Offer验证</p>
                        </div>
                        <Form onFinish={this.onFinish} ref={this.formRef} {...formLayout}>
                            <Form.Item
                                name="reqNo"
                                label={<>
                                    <span>雨虹需求ID</span>
                                    <Tooltip title="若是后增加的需求请将候选人转移一下状态，以便获取到新的雨虹需求ID">
                                        <span style={{ marginTop: '-4px', paddingLeft: '4px', paddingRight: '6px' }}><QuestionCircleOutlined /></span>
                                    </Tooltip>
                                </>}
                                required
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择雨虹需求ID',
                                    },
                                ]}
                            >
                                <Select showSearch
                                    placeholder="---请选择雨虹需求ID---"
                                >
                                    {this.state.reqNos.map((opt) => (
                                        <Option key={opt.optId}>{opt.optName}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name="staffName"
                                label="Offer所有者"
                                required
                                rules={[
                                    {
                                        required: false,
                                        message: '请输入Offer所有者',
                                    },
                                ]}
                            >
                                <Input readOnly={true} defaultValue={this.state.stfName} value={this.state.stfName} disabled></Input>
                            </Form.Item>
                            <Form.Item
                                name="staffNo"
                                label="Offer所有者工号"
                                required
                                rules={[
                                    {
                                        required: false,
                                        message: '请输入Offer所有者工号',
                                    },
                                ]}
                            >
                                <Input readOnly={true} defaultValue={this.state.stfCode} value={this.state.stfCode} disabled></Input>
                            </Form.Item>
                            <Form.Item>
                                <Button type="prmary" htmlType="submit">保存</Button>
                                <label style={{marginLeft:'10px'}}>保存后别忘记转移至offer阶段，方便EHR抓取数据</label>
                            </Form.Item>
                        </Form>
                    </>
                )
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}